import React, { useMemo } from 'react';

import { css, cx } from '@emotion/css';

import { useStyles } from '@/hooks/useStyles.ts';
import { CardContent } from '@/uiKit/atoms/card/CardContent.tsx';

export type PrescriptionSignContentProps = {
  prescription: Blob;
  className?: string;
};

export const PrescriptionSignContent: React.FC<
  PrescriptionSignContentProps
> = ({ prescription, className }) => {
  const styles = useStyles(makeStyles);
  const pdf = useMemo(() => {
    return URL.createObjectURL(
      new Blob([prescription], { type: 'application/pdf' }),
    );
  }, [prescription]);
  return (
    <CardContent className={cx(styles.container, className)}>
      <iframe className={styles.iframe} src={pdf} />
    </CardContent>
  );
};

const makeStyles = () => ({
  container: css({
    width: '100%',
    padding: 0,
  }),
  iframe: css({
    border: 'none',
    width: '100%',
    minHeight: '500px',
    margin: 0,
  }),
});
